export * from './auth-header';

export const accessToken  = JSON.parse(localStorage.getItem('access_token'));